class ShippingRates extends HTMLElement {
  constructor() {
    super();

    this.zipCode = "";

    this.querySelector("input").onkeyup = () => this.zipcodeMask();

    this.querySelector("button").onclick = () => this.calculateShippingRates();
  }

  zipcodeMask() {
    let zipcode = this.querySelector("input").value;
    zipcode = zipcode
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{3})\d+?$/, "$1");

    this.querySelector("input").value = zipcode;

    if (this.querySelector("input").value.length === 9) {
      this.querySelector("#submit-zipcode").disabled = false;
      this.zipCode = zipcode;
    } else this.querySelector("#submit-zipcode").disabled = true;
  }

  calculateShippingRates() {
    var this2 = this;

    this2.querySelector("#rates").innerHTML = "";
    this2.querySelector("#submit-zipcode").innerHTML =
      '<div class="loading-spinner"></div>';
    this2.querySelector("#submit-zipcode").disabled = true;

    // grab the current cookie for the cart and we store it
    var cartCookie = this.getCookie("cart"),
      tempCookieValue =
        "temp-cart-cookie___" + Date.now() + parseInt(Math.random() * 1000),
      fakeCookieValue =
        "fake-cart-cookie___" + Date.now() + parseInt(Math.random() * 1000); // if not found, make a new temp cookie

    if (!cartCookie) {
      this.updateCartCookie(tempCookieValue);

      cartCookie = this.getCookie("cart");
    } // if found but has a weird length, bail

    if (cartCookie.length < 32) {
      return;
    } // change the cookie value to a new 32 character value

    this.updateCartCookie(fakeCookieValue); // add the product to our fake cart
    fetch(theme.routes.cart_add_url, {
      body: `{"form_type":"product","id":"${
        this.querySelector("#product-id").innerText
      }","quantity":"1"}`,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
      method: "POST",
    }).then(function (response) {
      response
        .json()
        .then(function () {
          fetch(
            `/cart/shipping_rates.json?shipping_address[zip]=${this2.zipCode}&shipping_address[country]=Brazil&shipping_address[province]=SP`,
            {
              credentials: "same-origin",
              method: "GET",
            }
          )
            .then(function (response) {
              response.json().then(function (result) {
                this2.querySelector("#submit-zipcode").innerHTML = "Calcular";
                this2.querySelector("#submit-zipcode").disabled = false;
                result.shipping_rates.unshift({
                  name: "Retirada no local",
                  price: "0.00",
                  delivery_days: [1, 1],
                });
                result.shipping_rates.forEach((rate) => {
                  const node = document.createElement("li");
                  if (rate.name === "Local Delivery")
                    rate.name = "Entrega local";
                  if (!rate.delivery_days[1]) {
                    rate.delivery_days = [1, 1];
                  }
                  node.innerText = `${rate.name}: ${
                    rate.price === "0.00"
                      ? "grátis"
                      : "R$ " + rate.price.replace(".", ",")
                  } - Até ${rate.delivery_days[1]} dias úteis`;
                  this2.querySelector("#rates").appendChild(node);
                });
              });

              this2.updateCartCookie(cartCookie); // We can restore the cookie
            })
            ["catch"](function () {
              this2.updateCartCookie(cartCookie);
            });
        })
        ["catch"](function () {
          // We have error so we have to reset cookie
          this2.updateCartCookie(cartCookie);
        });
    });
  }

  getCookie(name) {
    var value = "; ".concat(document.cookie),
      parts = value.split("; " + name + "=");

    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
  }

  updateCartCookie(value) {
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    document.cookie = "cart="
      .concat(value, "; expires=")
      .concat(date.toUTCString(), "; path=/");
  }
}

customElements.define("shipping-rates", ShippingRates);
